import Avatar from "../../../components/common/Avatar";
import config from "../../../utils/config/config";
import { BUTTON_COLOR } from "../../../utils/ColorPicker";


const BotDetailsView = (props) => {
    const { bot, subscribeToBot, createConversation, style } = props;

    if (!bot) return;

    return (
        <div className="flex flex-col mt-6" style={style}>
            <div
                className="flex items-start p-3 list justify-between"
                style={style}
            >
                <div className="flex">
                    <div>
                        <Avatar
                            imgSrc={`${config?.contentURL ?? ""}${bot?.logoUrl ?? ""}`}
                            size={64}
                            height={64}
                        />
                    </div>
                    <div className="ml-3">
                        <h5 className={`text-[#4A4A4A] text-[20px]`}>{bot.botName}</h5>
                        <div style={{ color: "#666666" }} className="my-2">
                            <small>
                                <span style={{ color: BUTTON_COLOR }}>Free</span> |{" "}
                                {bot.developer ?? "FrontM"}
                            </small>
                        </div>
                        <label className={`text-[#999999] text-[14px]`}>
                            {bot.description ?? ""}
                        </label>
                    </div>
                </div>
                <div>
                    {bot.subscribed && (
                        <div className="ml-3">
                            {/* {localBot && localBot.version !== bot.version ? (
                                <div
                                    className={`btn btn-sm btn-outline-info btn-install `}
                                    onClick={() => {
                                        subscribeToBot(bot.botId);
                                        setTimeout(() => {
                                            setLocalBot(bot);
                                        }, 2000);
                                    }}
                                >
                                    Update
                                </div>
                            ) : ( */}
                            <div
                                className={`rounded-[6px] text-white font-bold text-[14px] px-[6px] py-[3px] cursor-pointer`}
                                onClick={() => createConversation(bot)}
                                style={{ backgroundColor: BUTTON_COLOR }}
                            >
                                Open
                            </div>
                            {/* )} */}
                        </div>
                    )}
                    {!bot.subscribed && (
                        <div className="ml-3">
                            <div
                                className={`btn btn-outline-info btn-install `}
                                onClick={() => subscribeToBot(bot.botId)}
                            >
                                Install
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className="flex flex-col p-3">
                <h6 className={` pb-2 text-[16px]`}>Information</h6>
                <div className="p-2">
                    <div className="flex justify-between">
                        <div className={`text-muted text-[#6c757d]`}>Version</div>
                        <div>{bot.version}</div>
                    </div>
                    <hr
                        style={{
                            borderTop: "1px solid #F4F4F4",
                            marginTop: "0.5rem",
                            marginBottom: "0.5rem",
                        }}
                    />
                    <div className="flex justify-between">
                        <div className={`text-muted text-[#6c757d]`}>Developer</div>
                        <div>{bot.developer}</div>
                    </div>
                    <hr
                        style={{
                            borderTop: "1px solid #F4F4F4",
                            marginTop: "0.5rem",
                            marginBottom: "0.5rem",
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default BotDetailsView;
